import { render } from "./PhysicianDeterminationForm.vue?vue&type=template&id=1c65b1ae&scoped=true"
import script from "./PhysicianDeterminationForm.vue?vue&type=script&lang=js"
export * from "./PhysicianDeterminationForm.vue?vue&type=script&lang=js"

import "./PhysicianDeterminationForm.vue?vue&type=style&index=0&id=1c65b1ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c65b1ae"]])

export default __exports__